var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"portotemplate"}},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"main",attrs:{"role":"main"}},[_c('div',{staticClass:"container"},[_c('v-dialog',{attrs:{"clickToClose":false,"pivotY":Number(0.9),"maxHeight":"400px"}}),_vm._v(" "),_c('router-view',{attrs:{"dadosLeilao":_vm.dadosLeilao,"dadosModeradorId":_vm.dadosModerador}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d682b538","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 